/* @ngInject */
export default function NvTimelineSectionHeader(
  _,
  TimelinesManager,
  CurrentCourseManager,
  CurrentUserManager,
  FilterCoursesManager,
  $uibModal,
  nvUtil,
  ConfirmationOverlays,
  config,
) {
  return {
    scope: {
      lectureSection: '=',
      updateLectureSection: '&?',
      parent: '=?',
      index: '=?',
    },
    controller: function ctrl($scope, $element, $attrs) {
'ngInject';
      const vm = this;
      vm.TimelinesManager = TimelinesManager;
      vm.CurrentUserManager = CurrentUserManager;
      vm.CurrentCourseManager = CurrentCourseManager;
      vm.formId = nvUtil.randomPositiveInteger();
      vm.openPopover = false;
      vm.isCopyToDropdownOpen = false;
      vm.lectureSection.copyToStatus = '';
      vm.config = config;

      vm.contentType = 'SECTION';
      vm.content = vm.lectureSection;

      const filterCurrentCourse = ({ catalogId, isJourney }) => catalogId !== CurrentCourseManager.course.catalogId && !isJourney;
      const activeOfferings = FilterCoursesManager.coursesForTab(_.filter(CurrentUserManager.courses, filterCurrentCourse), 'active');
      const futureOfferings = FilterCoursesManager.coursesForTab(_.filter(CurrentUserManager.courses, filterCurrentCourse), 'future');
      const demoOfferings = FilterCoursesManager.coursesForTab(_.filter(CurrentUserManager.courses, filterCurrentCourse), 'demo');
      vm.categories = [futureOfferings, activeOfferings, demoOfferings];
      vm.hasCourses = _.some(vm.categories, (c) => c.length);

      vm.lastCopyToOfferingVisible = function () {
        return vm.CurrentUserManager.lastCopyToOffering && (CurrentCourseManager.course.catalogId !== vm.CurrentUserManager.lastCopyToOffering);
      };

      vm.openCopyToDropdown = function () {
        vm.isCopyToDropdownOpen = true;
      };

      vm.findLastCopiedOffering = function () {
        let lastCopiedOffering = null;
        _.each(CurrentUserManager.courses, (course) => {
          if (course.catalogId === vm.CurrentUserManager.lastCopyToOffering) {
            lastCopiedOffering = course;
          }
        });
        return lastCopiedOffering;
      };

      vm.copyLastSelected = function () {
        vm.isCopyToDropdownOpen = false;
        const course = vm.findLastCopiedOffering();
        const { content, contentType } = vm;
        vm.uibModalInstance = $uibModal.open({
          backdrop: 'static',
          templateUrl: 'timelines/templates/copy-to-offering-modal.html',
          controller: 'CopyToOfferingModalCtrl as vm',
          windowClass: 'copy-to-modal',
          resolve: {
            course,
            content,
            type: () => contentType,
            updateCopyStatus: () => vm.updateCopyStatus.bind(vm),
          },
        });
      };

      vm.updateCopyStatus = function (status) {
        vm.lectureSection.copyToStatus = status;
      };

      vm.updateDeadlines = function () {
        const modal = $uibModal.open({
          templateUrl: 'timelines/templates/bulk-edit-deadline-modal.html',
          controller: 'BulkEditDeadlineCtrl as vm',
          windowClass: 'full-screen-modal-handheld full-screen-modal-tablet bulk-edit-deadline-modal',
          resolve: {
            section: vm.lectureSection,
          },
        });
      };

      vm.updateAllReleaseDates = function () {
        const modal = $uibModal.open({
          templateUrl: 'timelines/templates/bulk-edit-release-dates-modal.html',
          controller: 'BulkEditReleaseDatesCtrl as vm',
          windowClass: 'full-screen-modal-handheld full-screen-modal-tablet bulk-edit-deadline-modal',
          resolve: {
            section: vm.lectureSection,
          },
        });
      };

      vm.deleteSection = function () {
        const lectureCount = vm.lectureSection.hasLecturePages();
        if (lectureCount) {
          const modalInstance = ConfirmationOverlays.openConfirmationModal('timelines/templates/modal-delete-section-confirmation.html',
            'AttachModalResolvesToVmCtrl', {
              vmResolves() {
                return {
                  lectureCount,
                  isSubSection: false,
                  section: vm.lectureSection,
                  CurrentCourseManager,
                };
              },
            });

          modalInstance.result.then(() => {
            vm.TimelinesManager.removeLectureSection(vm.lectureSection.id, 'LectureSection', null, false);
          });
        } else {
          vm.TimelinesManager.removeLectureSection(vm.lectureSection.id, 'LectureSection', null, false);
        }
      };
    },
    controllerAs: 'vm',
    bindToController: true,
    templateUrl: 'timelines/templates/nv-timeline-section-header.html',
  };
}
